import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import AnimateOnScroll from '../shared/AnimateOnScroll';
import Button from '../shared/Button';
import './Hero.css';

// Importing talent images
import talent2 from '../../assets/images/talent-2.png';

import NocDashboard from './NocDashboard';

function Hero() {
  const [textIndex, setTextIndex] = useState(0);
  const rotatingTexts = ['Managed IT & Cloud.', '24/7 Cybersecurity.', 'Managed Virtual Teams.'];

  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % rotatingTexts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [rotatingTexts.length]);

  return (
    <section className="hero-split">
      <div className="hero-grid-pattern"></div>
      
      <div className="hero-split-container section-container">
        <div className="hero-content-left">
          <AnimateOnScroll className="hero-text-content">
            <h1 className="hero-title-main">
              Your Enterprise MSP for
              <span className="text-highlight-blue anim-fade-in" key={textIndex}>
                {rotatingTexts[textIndex]}
              </span>
            </h1>
            <p className="hero-subtitle-main">
              Combining 24/7 Managed IT Infrastructure, Cloud Management & SOC2/HIPAA Cybersecurity with Dedicated Managed Virtual Workforces.
            </p>

            <div className="hero-trust-badges-bar">
              <div className="trust-badge-pill">⚡ 15-Min Response SLA</div>
              <div className="trust-badge-pill">🎧 24/7 Live Helpdesk</div>
              <div className="trust-badge-pill">🛡️ SOC2 & HIPAA Certified</div>
            </div>
            
            <div className="hero-actions-main">
              <Button href="/services/managed-it" variant="primary" className="btn-schedule">
                Get MSP Proposal <FaArrowRight />
              </Button>
              <Link to="/#msp-calculator" className="hero-link-secondary">
                Calculate Savings <span>→</span>
              </Link>
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="hero-trust-section" delay={300}>
            <p className="trust-text">Enterprise Infrastructure & SLA Partners</p>
            <div className="trust-logos">
              <span className="trust-logo">Google Cloud (GCP)</span>
              <span className="trust-logo">Microsoft Azure</span>
              <span className="trust-logo">SOC2 Type II</span>
            </div>
          </AnimateOnScroll>
        </div>

        <div className="hero-visual-right">
          <AnimateOnScroll className="hero-visual-wrapper">
            <NocDashboard />
          </AnimateOnScroll>
        </div>
      </div>
    </section>
  );
}

export default Hero;




